@reference "../../styles/ui.css";

.page-of {
  @apply gap-1 flex items-center shrink-0 text-gray-500;
}
